import styled from '@emotion/styled'
import { useGetRole } from 'api/auth/hooks'
import { useGetPublisher } from 'api/publisher/hooks'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { colors } from 'styles/theme'
import { storage } from 'utils/localStorage'

const Navbar = () => {
  const [showNavLinks, setShowNavLinks] = useState<boolean>(true)

  const router = useRouter()
  const { userRole } = useGetRole()

  const publisherId = storage.getValue('publisherId')

  const { data: PublisherData } = useGetPublisher({ id: publisherId })
  const isPublisherEnabled = PublisherData?.enabled

  useEffect(() => {
    if (
      ['/applications', '/content-filters', '/account', '/billing'].includes(
        router.pathname
      )
    )
      setShowNavLinks(true)
    else setShowNavLinks(false)
  }, [router.pathname])

  if (userRole === 'publisher' && !isPublisherEnabled) {
    return null
  }

  return (
    <>
      {showNavLinks && (
        <Container>
          <Link as={'/'} passHref href="/applications">
            <LinkText currentLink={router.pathname === '/applications'}>
              Applications
            </LinkText>
          </Link>
          <Link passHref href="/content-filters">
            <LinkText currentLink={router.pathname === '/content-filters'}>
              Content Filters
            </LinkText>
          </Link>
          <Link passHref href="/billing">
            <LinkText currentLink={router.pathname === '/billing'}>
              Billing Settings
            </LinkText>
          </Link>
          {userRole !== 'publisher' && (
            <Link passHref href="/account">
              <LinkText currentLink={router.pathname === '/account'}>
                Account Settings
              </LinkText>
            </Link>
          )}
        </Container>
      )}
    </>
  )
}

const Container = styled('nav')`
  display: flex;
  gap: 24px;
  margin: 32px 32px 0;
  cursor: pointer;
`

const LinkText = styled.p((props: any) => ({
  color: props?.currentLink ? colors.gray[900] : colors.gray[700],
  paddingBottom: '9px',
  borderBottom: props?.currentLink
    ? `3px solid ${colors.purple[700]}`
    : 'unset',
}))

export default Navbar
